import { WebsocketMessage } from 'app/types';

import DisciplineBlockingTickets from '../updates-actions/DisciplineBlockingTickets';
import FileGenerated from '../updates-actions/FileGenerated';
import InspectionFileDownloaded from '../updates-actions/InspectionFileDownloaded';
import InspectionFiles from '../updates-actions/InspectionFiles';
import InspectionsHistory from '../updates-actions/InspectionsHistory';
import MetricsData from '../updates-actions/MetricsData';
import SetInspectionSwo from '../updates-actions/SetInspectionSwo';
import SetJobSwo from '../updates-actions/SetJobSwo';
import TicketCommentCreated from '../updates-actions/TicketCommentCreated';

export interface UpdatesListenerActionsProps {
  message: WebsocketMessage;
}

/**
 * Split messages into actions
 * @param props
 * @returns
 */
export default function UpdatesListenerActions(props: UpdatesListenerActionsProps) {
  const { message } = props;

  /**
   * PDF File For Certificate
   */
  if (message.type === 'pdf_generated') {
    return <FileGenerated type="pdf" message={message} />;
  }

  /**
   * CSV File Generated
   */
  if (message.type === 'csv_generated') {
    return <FileGenerated type="csv" message={message} />;
  }

  /**
   * Get permit history
   */
  if (message.type === 'inspections_history') {
    return <InspectionsHistory message={message} />;
  }

  /**
   * Get permit history inspection files
   */
  if (message.type === 'inspection_files') {
    return <InspectionFiles message={message} />;
  }

  /**
   * Get permit history inspection files
   */
  if (message.type === 'accela_file_downloaded') {
    return <InspectionFileDownloaded message={message} />;
  }

  if (message.type === 'job_swo') {
    return <SetJobSwo message={message} />;
  }

  if (message.type === 'inspection_swo') {
    return <SetInspectionSwo message={message} />;
  }

  if (message.type === 'ticket_comment_created') {
    return <TicketCommentCreated message={message} />;
  }

  if (message.type === 'blocking_ticket') {
    return <DisciplineBlockingTickets message={message} />;
  }

  if (message.type.startsWith('metrics/')) {
    return <MetricsData message={message} />;
  }

  console.log('Unknown message type', message.type, message);

  return null;
}
